import { boot } from 'quasar/wrappers';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import { useAppStore } from 'stores/app';

export const defaultNonAuthHandlerFactory = (store) => () => {
  const appStore = useAppStore(store);
  appStore.setAuthDialog(true);
};

/**
 * TODO: Сделать описание для директивы авторизации
 */
export default boot(({ app, store }) => {
  const defaultNonAuthHandler = defaultNonAuthHandlerFactory(store);
  app.directive('auth', {
    mounted(el, binding, vnode, prevVnode) {
      const listener: (event: MouseEvent) => void = (event: MouseEvent) => {
        const authStore = useAuthStore(store);
        const { isAuthenticated } = authStore;
        if (isAuthenticated) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (binding.value && typeof binding.value === 'function') {
          binding.value(event, defaultNonAuthHandler);
        } else {
          defaultNonAuthHandler();
        }
      };
      el.addEventListener('click', listener, true);
      // @ts-ignore
      el.$destroy = () => el.removeEventListener('click', listener);
    },
    unmounted(el, binding, vnode, prevVnode) {
      // @ts-ignore
      el.$destroy();
    },
    getSSRProps(binding) {
      console.log('GET SSR', binding.value);
      return {
        // id: binding.value,
      };
    },
  });
});
